// Hook - lista Notify w danym watku.
// GET /api/ui/sales-crm/notify/by-thread/{threadId}
// Sprint 4 v4.1.

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetNotifyByThreadResponse } from 'api/types/notify';

export const getNotifyByThreadQueryKey = (threadId: number) =>
  ['sales-crm-notify', 'by-thread', threadId] as const;

const getNotifyByThread = (threadId: number): Promise<IGetNotifyByThreadResponse> =>
  axios.get(`/sales-crm/notify/by-thread/${threadId}`);

export const useGetNotifyByThread = (
  threadId: number,
  options?: UseQueryOptions<IGetNotifyByThreadResponse, IError>
) =>
  useQuery<IGetNotifyByThreadResponse, IError>(
    getNotifyByThreadQueryKey(threadId),
    () => getNotifyByThread(threadId),
    {
      enabled: threadId > 0,
      staleTime: 30_000,
      ...options
    }
  );
